export default function (value) {
  const numeric = Number.parseInt(value)
  if(isNaN(numeric)) return '--'
  const KB_UNIT = 1024
  const MB_UNIT = 1024 * 1024
  if (numeric > MB_UNIT) {
    return `${(value / MB_UNIT).toFixed(2)} Mb`
  } else if (numeric > KB_UNIT) {
    return`${(value / KB_UNIT).toFixed(2)} Kb`
  } else {
    return `${value} b`
  }
}